import { from, map, Observable } from 'rxjs';

// Layer unico Supabase → Observable, con gestione errori CENTRALIZZATA in UN solo punto.
// Supabase non rigetta MAI la Promise: risolve con { data, error }. Qui, appena `error` è
// valorizzato, LANCIAMO → l'Observable va in `error` e i consumer usano catchError / la
// error-callback in modo uniforme. Restituiamo direttamente `data` già "spacchettato".
// Se un domani Supabase cambia lo shape della risposta, si tocca SOLO questo file.
// Tipo errore allargato (strutturale, non PostgrestError): copre anche le risposte
// di storage/auth, che espongono solo `.message`.
export function doSupabaseCall<T>(
  query: PromiseLike<{ data: T | null; error: { message: string } | null }>,
): Observable<T> {
  return from(query).pipe(
    map(({ data, error }) => {
      if (null !== error) {
        throw new Error(error.message);
      }
      return data as T;
    }),
  );
}
